import DiscountContext from 'client/contexts/DiscountContext'
import { useContext } from 'react'

export const useDiscount = () => {
  const context = useContext(DiscountContext)
  if (!context) {
    throw new Error('useDiscount must be used within a DiscountProvider')
  }
  return context
}
